import { modelize } from '@finect/front-utils/modelize';

const arrayToObject = (entityArray) => {
  const schema = {};

  const normalized = entityArray.reduce((normalizedObject, item) => {
    const newNormalizedObject = normalizedObject;

    newNormalizedObject[item.id] = item;

    return newNormalizedObject;
  }, schema);

  return normalized;
};

const users = user => ({
  id: user.id,
  type: user.subtype,
  subtype: user.subtype,
  displayName: user.displayName.trim(),
  avatarURL: user.icon ? `/image/${user.icon}` : null,
  icon: user.icon ? user.icon : null,
  username: user.alias,
  alias: user.alias,
  email: user.email,
  firstName: user.name,
  lastName: user.surnames,
  profileURL: `usuario/${user.alias}`,
  headline: user.headline,
  certification: user.certification,
  adviser: user.adviser,
  stats: user.stats,
  unreadMessages: user.unreadMessages,
  isLoggedIn: true,
  risk: user.risk,
  achievements: user.achievements,
  administrations: user.administrations,
  advised: user.advised,
  aggregations: user.aggregations,
  isProfessional: user.isProfessional,
  organizations: user.organizations,
  features: user.features || [],
  notifications: user.notifications
});

// TODO cambiar formado adviserAt y certification para no hacer [0]
const authorV4 = (author) => {
  const [firstOrganization] = author.organizations || [];
  const [firstCertification] = author.certifications || [];
  return {
    id: author.id,
    image: `/image/${author.icon}`,
    type: author.subtype,
    name: author.displayName,
    alias: author.alias,
    url: author.web,
    adviserAt: firstOrganization
      ? {
        id: firstOrganization.id,
        name: firstOrganization.displayName,
        icon: `/image/${firstOrganization.icon}`,
        url: firstOrganization.web,
        badges: firstOrganization.badges || [],
        features: firstOrganization.features || [],
        private: firstOrganization.private
      }
      : null,
    certification: firstCertification
      ? {
        name: firstCertification.organization,
        icon: `/image/${firstCertification.icon}`,
        url: `/grupos/${firstCertification.alias}`
      }
      : null,
    stats: author.stats || {},
    features: author.features || []
  };
};

const authors = author => ({
  id: author.id,
  image: author.icon_url,
  type: author.type,
  name:
    author.type === 'company'
      ? `${author.name}`
      : `${author.first_name}${author.last_name ? ` ${author.last_name}` : ''}`,
  alias: author.alias,
  url: author.url,
  adviserAt: author.adviser_at
    ? {
      id: author.adviser_at.company_id,
      name: author.adviser_at.company_name,
      icon: author.adviser_at.company_icon_url,
      url: author.adviser_at.company_url,
      badges: author.adviser_at.badges || []
    }
    : null,
  certification: author.certification
    ? {
      name: author.certification.organization,
      icon: author.certification.icon_url,
      url: author.certification.url
    }
    : null,
  stats: author.stats || {},
  features: author.features || []
});
// Not clear what stats should contain at this point, now is empty

const tags = tag => ({
  id: tag.id,
  name: tag.name,
  description: tag.description,
  following: tag.is_followed,
  stats: {
    questions: typeof tag.questions_count === 'number' ? tag.questions_count : null,
    followers: typeof tag.users_count === 'number' ? tag.users_count : null
  },
  synonyms: tag.synonyms || []
});

const commentV4 = comment => ({
  id: comment.id,
  author: comment.author,
  body: {
    content: JSON.stringify(comment.body.metadata)
  },
  products: comment.products || [],
  // moderated: comment.hasOwnProperty('is_moderated') ? Boolean(comment.is_moderated) : false,
  moderated: true,
  created: comment.created,
  updated: comment.updated
    ? {
      revision: comment.updated,
      date: comment.updated
    }
    : null
});

const comments = comment => ({
  id: comment.id,
  author: comment.author,
  body: {
    content: comment.body.content
  },
  products: comment.products || [],
  moderated: comment.hasOwnProperty('is_moderated') ? Boolean(comment.is_moderated) : false,
  created: comment.created_at,
  updated: comment.updated
    ? {
      revision: comment.updated.revision,
      date: comment.updated.date
    }
    : null
});

const answerV4 = answer => ({
  id: answer.id,
  author: answer.author,
  body: {
    content: JSON.stringify(answer.body.metadata)
  },
  products: answer.products || [],
  created: answer.created,
  updated: answer.updated
    ? {
      revision: answer.updated,
      date: answer.updated
    }
    : null,
  stats: {
    votes: answer.socialStats.likes
  },
  moderated: answer.moderated ? Boolean(answer.moderated) : false,
  selected: answer.selected,
  comments: answer.comments ? modelize(answer.comments, commentV4) : []
});

const answers = answer => ({
  id: answer.id,
  author: answer.author,
  body: {
    content: answer.body.content
  },
  products: answer.products || [],
  created: answer.created_at,
  updated: answer.updated
    ? {
      revision: answer.updated.revision,
      date: answer.updated.date
    }
    : null,
  stats: {
    votes: answer.stats.votes
  },
  moderated: answer.hasOwnProperty('is_moderated') ? Boolean(answer.is_moderated) : false,
  voted: answer.is_voted,
  comments: answer.comments ? modelize(answer.comments, comments) : []
});

// eslint-disable-next-line no-shadow
const questionV4 = (question, authors) => ({
  id: question.id,
  author: question.author,
  authors: authors ? modelize(arrayToObject(authors), authorV4) : [],
  title: question.title,
  body: {
    content: JSON.stringify(question.body.metadata)
  },
  products: question.products || [],
  created: question.revision.created,
  updated: question.revision.updated
    ? {
      revision: question.revision.updated,
      date: question.revision.updated
    }
    : null,
  stats: {
    votes: question.socialStats.likes,
    answers: question.stats.answers,
    views: question.stats.views
  },
  closed: question.closed,
  // selectedAnswer: question.selected_answer || null,
  // answered: Boolean(question.answers), //MAL
  moderated: question.stats.moderated ? Boolean(question.stats.moderated) : false,
  tags: question.socialStats.tags ? modelize(question.socialStats.tags, tags) : [],
  comments: question.comments ? modelize(question.comments, commentV4) : [],
  answers: question.answers ? modelize(question.answers, answerV4) : []
});

const questions = question => ({
  id: question.id,
  author: question.author,
  authors: modelize(question.authors, authors),
  title: question.title,
  body: {
    content: question.body.content || ''
  },
  products: question.products || [],
  created: question.created_at,
  updated: question.updated
    ? {
      revision: question.updated.revision,
      date: question.updated.date
    }
    : null,
  stats: {
    votes: question.stats.votes,
    answers: question.stats.answers,
    views: question.stats.views
  },
  closed: question.closed,
  selectedAnswer: question.selected_answer || null,
  // following: question.is_following,
  // voted: question.is_voted,
  answered: question.is_answered,
  moderated: question.hasOwnProperty('is_moderated') ? Boolean(question.is_moderated) : false,
  tags: modelize(question.tags, tags),
  comments: question.comments ? modelize(question.comments, comments) : null,
  answers: question.answers ? modelize(question.answers, answers) : null
});

export const models = {
  users,
  questionV4,
  questions,
  authorV4,
  authors,
  tags,
  commentV4,
  comments,
  answerV4,
  answers
};
